import { useState } from "react";
import { SectionLabel } from "@/components/SectionLabel";

export const Poll = ({ poll, onVote }) => {
  const [hasVoted, setHasVoted] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  if (!poll) return null;

  const totalVotes = Object.values(poll.votes || {}).reduce((a, b) => a + b, 0);

  const handleVote = (index) => {
    if (hasVoted) return;
    
    setSelectedOption(index);
    setHasVoted(true);
    onVote(index);
  };

  const getPercentage = (index) => {
    const votes = poll.votes?.[String(index)] || 0;
    if (totalVotes === 0) return 0;
    return Math.round((votes / totalVotes) * 100);
  };

  return (
    <div className="sidebar-block pb-9 border-b border-scoop-border fade-in" data-testid="poll">
      <SectionLabel icon="💬" title="What Do You Think?" showDay={true} />
      
      <p className="font-display font-bold text-base leading-snug text-scoop-ink mb-4">
        {poll.question}
      </p>
      
      <div className="space-y-2">
        {poll.options.map((option, index) => (
          <button
            key={index}
            onClick={() => handleVote(index)}
            className={`poll-option w-full bg-white border-2 rounded p-2.5 px-3.5 text-left text-sm font-medium text-gray-700 flex items-center justify-between relative ${
              hasVoted && selectedOption === index 
                ? "border-scoop-blue bg-[#EEF5FF]" 
                : "border-scoop-border hover:border-scoop-blue hover:bg-[#EEF5FF]"
            } ${hasVoted ? "cursor-default" : "cursor-pointer"}`}
            disabled={hasVoted}
            data-testid={`poll-option-${index}`}
          >
            {hasVoted && (
              <div 
                className="poll-bar"
                style={{ width: `${getPercentage(index)}%` }}
              />
            )}
            <span className="relative z-10">{option}</span>
            {hasVoted && (
              <span className="text-sm font-bold text-scoop-blue relative z-10">
                {getPercentage(index)}%
              </span>
            )}
          </button>
        ))}
      </div>
      
      <p className="text-[0.67rem] text-gray-400 mt-2.5 tracking-wide">
        No account needed · Responses are anonymous
      </p>
    </div>
  );
};

export default Poll;
